
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/[[...path]]",
      function () {
        return require("private-next-pages/[lang]/[[...path]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/[[...path]]"])
      });
    }
  